var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.groupLiveVisible)?_c('div',{staticClass:"group-live-mask"},[_c('div',{staticClass:"live-container"},[_c('div',{staticClass:"video-wrap"},[(_vm.channel === 3 && _vm.userID !== _vm.anchorID)?[_c('live-player')]:[_c('live-pusher')]],2),_vm._v(" "),_c('div',{staticClass:"chat-wrap"},[(_vm.groupLiveVisible)?_c('live-chat'):_vm._e()],1)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40258632","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/im/group-live/index.vue
// module id = null
// module chunks = 